"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaEcumenopolis = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const CardRenderItem_1 = require("../render/CardRenderItem");
const MoonCard_1 = require("./MoonCard");
const TileType_1 = require("../../TileType");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
class LunaEcumenopolis extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_ECUMENOPOLIS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.CITY, Tags_1.Tags.MOON],
            cost: 35,
            reserveUnits: Units_1.Units.of({ titanium: 2 }),
            metadata: {
                description: 'Spend 2 Titanium. ' +
                    'Place 2 colony tiles adjacent to at least 2 other colony tiles and raise Colony rate 2 steps. ' +
                    'Increase your TR 1 step for each 2 steps of the colony rate.',
                cardNumber: 'M84',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().titanium(2).nbsp();
                    b.text('2').moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE).asterix().br;
                    b.tr(1).slash().moonColonyRate({ amount: 2 });
                }),
            },
        }, {
            tilesBuilt: [TileType_1.TileType.MOON_COLONY, TileType_1.TileType.MOON_COLONY],
        });
    }
    ;
    canPlay(player) {
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        const initialMoonColonyRate = MoonExpansion_1.MoonExpansion.getColonyRate(player);
        let trStepsIncreased = Math.min(constants_1.MAXIMUM_COLONY_RATE - initialMoonColonyRate, 2);
        const newColonyRate = Math.min(initialMoonColonyRate + 2, constants_1.MAXIMUM_COLONY_RATE);
        trStepsIncreased += Math.floor(newColonyRate / 2);
        const spaces = moonData.moon.getAvailableSpacesOnLand(player);
        const len = spaces.length;
        let firstSpaceId = '';
        let canPlaceTiles = false;
        const nextToTwoColonies = function (space) {
            const adjacentSpaces = moonData.moon.getAdjacentSpaces(space).filter((adjacentSpace) => {
                return MoonExpansion_1.MoonExpansion.spaceHasType(adjacentSpace, TileType_1.TileType.MOON_COLONY) || adjacentSpace.id === firstSpaceId;
            });
            return adjacentSpaces.length >= 2;
        };
        for (let x = 0; x < len; x++) {
            const first = spaces[x];
            if (nextToTwoColonies(first) === true) {
                firstSpaceId = first.id;
                for (let y = 0; y < len; y++) {
                    const second = spaces[y];
                    if (second.id === firstSpaceId)
                        continue;
                    if (nextToTwoColonies(second) === true) {
                        canPlaceTiles = true;
                    }
                }
            }
        }
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        Card_1.Card.setRedsWarningText(player, redsAreRuling ? trStepsIncreased : 0, this);
        if (!super.canPlay(player))
            return false;
        if (!canPlaceTiles)
            return false;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trStepsIncreased * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return true;
    }
    play(player) {
        player.game.defer(new CustomPlaceMoonTile(player));
        player.game.defer(new CustomPlaceMoonTile(player));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            const colonyRate = MoonExpansion_1.MoonExpansion.getColonyRate(player);
            player.increaseTerraformRatingSteps(Math.floor(colonyRate / 2));
            return undefined;
        }));
        return undefined;
    }
    getActionDetails(player, card) {
        const colonyRate = Math.min(MoonExpansion_1.MoonExpansion.getColonyRate(player) + 2, constants_1.MAXIMUM_COLONY_RATE);
        return new RedsPolicy_1.ActionDetails({ card: card, moonColonyRateIncrease: 2, TRIncrease: Math.floor(colonyRate / 2) });
    }
}
exports.LunaEcumenopolis = LunaEcumenopolis;
class CustomPlaceMoonTile extends PlaceMoonColonyTile_1.PlaceMoonColonyTile {
    getSpaces() {
        const moonData = MoonExpansion_1.MoonExpansion.moonData(this.player.game);
        const spaces = moonData.moon.getAvailableSpacesOnLand(this.player);
        const filtered = spaces.filter((space) => {
            const adjacentSpaces = moonData.moon.getAdjacentSpaces(space).filter((adjacentSpace) => {
                return MoonExpansion_1.MoonExpansion.spaceHasType(adjacentSpace, TileType_1.TileType.MOON_COLONY);
            });
            return adjacentSpaces.length >= 2;
        });
        return filtered;
    }
}
//# sourceMappingURL=LunaEcumenopolis.js.map